<style lang="less" scoped>
*{margin: 0;list-style-type:none;}
.center{width: 100%;display: flex;flex-direction: column;background: #fff;position: relative;}
.periodical{width: 1150px; margin: 0px auto; display: flex;flex-direction: column;margin-bottom: 20px;}
i{float: left;margin-top: -1px;margin-right: 8px;font-size: 20px;color: rgb(25, 159, 248);}
.logo{align-self: start;margin-top: 20px;
  span{font-size: 18px;color: rgb(49, 49, 49);}
}
.main{width: 1130px; margin: 0px auto; margin-left: 20px; display: flex;flex-direction: column;margin-bottom: 20px;}
.type{margin-top: 20px;margin-bottom:20px;
  .left{float: left;
    span{font-size: 18px;font-weight: 600;}}
  .right{float: right;cursor: pointer;
    span{font-size: 16px;font-weight: 600;color: rgb(17, 17, 17);}
    img{vertical-align: bottom;}
  }
}
ul{list-style: none;
  li{display: flex;margin-left: -40px;height: 100px;}
  li:last-child{border-bottom: 2px solid rgb(223, 222, 222);}
  li:hover{cursor: pointer;.title{color:rgb(53, 132, 196);}}
  img{width: 100px;height:80px;margin-right: 20px;}
  p{margin-top: 30px;white-space: nowrap; overflow: hidden; text-overflow:ellipsis;}
  .title{width: 420px;text-align: left;margin-right: 40px;}
  .author{width: 300px;text-align: left;margin-right: 40px;}
  .pdf{width: 60px;margin-right: 60px;margin-top: 33px;}
}
</style>

<template>
  <div class="center">
    <div class="periodical">
      <div class="logo">
        <i class="iconfont icon-zixun"></i><span>东盟各国投资专题</span>
      </div>
      <div class="main">
        <div class="type">
          <div class="left">
            <span>老挝</span>
          </div>
          <div class="right" @click = getMore(Laos)>
            <span>查看更多</span>
            <img src="static/images/zlkindex/arrow.png" />
          </div>
        </div>
        <ul class="catalogue">
          <li v-for="(item, index) in LaosList" :key="index" @click="lookPDF(item)">
            <img v-if="item.thumb !== ''"  :src="item.thumb" />
            <img v-if="item.thumb === ''"  src="static/images/moren.jpg" />
            <p class="title">{{ item.title }}</p>
            <p class="author">{{ item.author }}</p>
            <p class="pdf"><i class="iconfont icon-pdf" style="color: #FF5562"></i>PDF</p>
            <p class="time">{{ item.addtime * 1000 | formatDateYM() }}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 东盟各国投资专题 何宽
 */
import filters from '../method/filter'
export default {
  name: '',
  mixins: [filters],
  data()
  {
    return {
      LaosList: [], //老挝
      Laos: 427
    }
  },
  created()
  {
    this.getData()
  },
  methods:
  {
    //获取数据
    getData()
    {
      let paras1 = {cmd: 'query', _major: 11, _minor: 67, _exp: 'catid=427 and examine = 0', orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 10}
      window.post.getPost(paras1).then((ret) =>
      {
        this.LaosList = ret[0].data
      })
    },
    //查看更多
    getMore(num)
    {
      let url = this.$router.resolve({path: '/DMinvestmentList', query: {catid: num}})
      window.open(url.href, '_blank')
    },
    //查看pdf文件
    lookPDF(item)
    {
      let url = this.$router.resolve({name: 'PDFfile', query: {url: item.pdf}})
      window.open(url.href, '_blank')
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/plugins/app/project/DMinvestment.vue